// extracted by mini-css-extract-plugin
module.exports = {"image":"slider-module--image--1gkH5","sticker":"slider-module--sticker--15qAz"};